module.exports = __webpack_public_path__ + "images/339f6ed390c44a156952ef9f1b5776c2-platinum_badge.png";